import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import "./index.css"
import { ReactKeycloakProvider } from "@react-keycloak/web"
import keycloakCfg from "./configs/keycloak"
import { Provider } from "react-redux"
import { store } from "./redux/store"
// import reportWebVitals from './reportWebVitals';

// Google Tag Manager — only in production
if (process.env.NODE_ENV === "production") {
  const GTM_ID = "GTM-WQSVDPS"

  // GTM head script
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" })
  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)

  // GTM noscript iframe
  const noscript = document.createElement("noscript")
  const iframe = document.createElement("iframe")
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`
  iframe.height = "0"
  iframe.width = "0"
  iframe.style.display = "none"
  iframe.style.visibility = "hidden"
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)

  // Biskoui cookie consent widget
  window.biskouiSettings = { clientId: "1210642" }
  const biskouiScript = document.createElement("script")
  biskouiScript.async = true
  biskouiScript.src = "https://cdn.biskoui.com/sdk.js"
  document.head.appendChild(biskouiScript)
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* checkLoginIframe désactivé : la CSP frame-ancestors du Keycloak v26 interdit
          d'iframer auth.heig-vd.ch, et ce mécanisme est déprécié (cookies tiers bloqués).
          pkceMethod requis : le client ateliers-jp-app exige PKCE S256 sur le realm main */}
      <ReactKeycloakProvider authClient={keycloakCfg} initOptions={{ checkLoginIframe: false, pkceMethod: "S256" }}>
        <App />
      </ReactKeycloakProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)
